<div class="session-history-container">
    <!-- Header Section -->
    <header class="page-header">
        <h1>Session History</h1>
        <p>View your past sessions and outcomes.</p>
    </header>

    <!-- Filter Section -->
    <div class="filter-tabs">
        <button *ngFor="let filter of filters" [class.active]="activeFilter === filter.value"
            (click)="setFilter(filter.value)">
            {{ filter.label }}
        </button>
    </div>

    <!-- History Card -->
    <div class="history-card">
        <div class="table-responsive">
            <table class="table history-table">
                <thead>
                    <tr>
                        <th>STUDENT</th>
                        <th>DATE</th>
                        <th>DURATION</th>
                        <th>TOPIC</th>
                        <th>STATUS</th>
                        <!-- <th>RATING</th> -->
                    </tr>
                </thead>
                <tbody *ngIf="isLoading">
                    <tr *ngFor="let i of [1,2,3,4,5,6,7,8,9,10]">
                        <td>
                            <div class="student-cell">
                                <div class="avatar-sm skeleton-shimmer"></div>
                                <div class="skeleton-shimmer skeleton-text-name"></div>
                            </div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-text-wide"></div>
                        </td>
                        <td>
                            <div class="skeleton-shimmer skeleton-badge-sm"></div>
                        </td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isLoading">
                    <tr *ngFor="let record of history">
                        <td>
                            <div class="student-cell">
                                <div class="avatar-sm" [ngClass]="record.avatarColorClass">
                                    {{ record.initials }}
                                </div>
                                <span class="student-name">{{ record.studentName }}</span>
                            </div>
                        </td>
                        <td data-label="DATE"><span class="date-text">{{ record.date }}</span></td>
                        <td data-label="DURATION"><span class="duration-pill">{{ record.duration }}</span></td>
                        <td data-label="TOPIC"><span class="topic-text">{{ record.topic }}</span></td>
                        <td data-label="STATUS">
                            <app-status-badge [status]="record.status"></app-status-badge>
                        </td>
                    </tr>
                    <tr *ngIf="history.length === 0">
                        <td colspan="6" class="text-center py-5">
                            <div class="no-data text-center">
                                <i class="bi bi-clock-history fs-1 text-muted d-block mb-3"></i>
                                <p class="text-muted fw-medium mb-0">No session history found for the selected filter.
                                </p>
                                <small class="text-muted">Your past sessions will appear here once they are completed or
                                    processed.</small>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Table Footer / Pagination -->
        <div class="table-footer" *ngIf="history.length > 0">
            <div class="pagination-bar">
                <span class="items-per-page-label">Items per page:</span>
                <div class="custom-select-wrapper" [class.open]="pageSizeDropdownOpen" #pageSizeDropdownRef>
                    <button class="custom-select-trigger" (click)="pageSizeDropdownOpen = !pageSizeDropdownOpen"
                        type="button">
                        <span>{{ pageSize }}</span>
                        <svg class="caret-icon" [class.rotated]="pageSizeDropdownOpen" width="9" height="5"
                            viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 1l3.5 3L8 1" stroke="#9ca3af" stroke-width="1.4" stroke-linecap="round"
                                stroke-linejoin="round" />
                        </svg>
                    </button>
                    <ul class="custom-select-panel" *ngIf="pageSizeDropdownOpen">
                        <li *ngFor="let size of pageSizeOptions" class="custom-select-option"
                            [class.selected]="size === pageSize" (click)="selectPageSize(size)">
                            {{ size }}
                        </li>
                    </ul>
                </div>
                <span class="page-range">
                    {{ (currentPage - 1) * pageSize + 1 }} – {{ getEndItem() }} of {{ totalCount }}
                </span>
                <div class="page-nav-buttons">
                    <button class="nav-btn" (click)="prevPage()" [disabled]="currentPage === 1">
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <button class="nav-btn" (click)="nextPage()" [disabled]="currentPage >= totalPages">
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>